var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        'ds-polling-wrapper': true,
        'ds-polling-wrapper--pending': _vm.isPending,
        'ds-polling-wrapper--rejected': _vm.isRejected,
        'ds-polling-wrapper--resolved': _vm.isResolved,
    }},[_vm._t("default",null,null,{ status: _vm.status, isPending: _vm.isPending, isRejected: _vm.isRejected, isResolved: _vm.isResolved, requestCount: _vm.requestCount, response: _vm.fetchedData })],2)}
var staticRenderFns = []

export { render, staticRenderFns }